import { Stack } from "@mantine/core"

import { CommunicationStudioClasses } from "@tfg/types/constants/communication-studio.constant"
import { AGECResponses } from "@tfg/types/endpoints/agec"
import { ProductSheetComponent } from "@tfg/types/schemas/communication-studio/components"
import { ScopedConfigurationsResponse } from "@tfg/types/types/communication-studio/configurations.types"

import { ProductSheetComponentRenderer } from "./page-components/ProductSheetComponentRenderer"

interface Props {
  agecData: AGECResponses.GenericAgecData
  configuration: ScopedConfigurationsResponse
  productPageComponents: ProductSheetComponent[]
}

export const GenericComponentsAGECPage = ({
  agecData,
  configuration,
  productPageComponents,
}: Props) => {
  if (!productPageComponents || productPageComponents.length === 0) {
    return null
  }
  productPageComponents.sort((a, b) => a.order - b.order)
  return (
    <Stack align="center" mb={50} p={"0.1rem"}>
      <Stack gap="sm" className={CommunicationStudioClasses.CONTENT_BLOCKS}>
        {productPageComponents?.map((component, index) => {
          return (
            <ProductSheetComponentRenderer
              key={`component-${index}`}
              component={component}
              agecData={agecData}
              configuration={configuration}
            />
          )
        })}
      </Stack>
    </Stack>
  )
}
